import React from 'react';
import { Skeleton } from 'antd';
import styles from './index.module.scss';

const ImagesSkeleton = ({ size = 0 }) => {
  return Array.from({ length: size }).map((_, index) => (
    <Skeleton
      key={index}
      className={styles.fileSkeleton}
      active
      avatar={{ shape: 'square' }}
      paragraph={false}
      title={false}
    />
  ));
};

export default ImagesSkeleton;
